// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizCompanyDataViewGraph_cont__1Ngz0","box":"BizCompanyDataViewGraph_box__3XpuY","box-nodata":"BizCompanyDataViewGraph_box-nodata__29yD3"};